export default __webpack_public_path__ + "static/media/pa_logo_new.dad4168d.svg";